/**
 * React key for a row card, derived from the entity id when there is one.
 *
 * Favourite rows are patched in place on add/remove from My List, so a purely
 * positional key makes React reuse a card instance - together with its internal
 * state, e.g. the My List toggle icon - for a different entity. Continue
 * watching items have no `id` and stay keyed by position.
 */
export function getRowItemKey(item: unknown, idx: number): string | number {
  const id = (item as { id?: unknown } | null | undefined)?.id

  return typeof id === 'number' || typeof id === 'string' ? `id:${id}` : idx
}
